import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as H}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as L}from"../../icon-registry.js";const a=L("new_zealand",H`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <path
                d="M0 4.5H24V20.5H0V4.5Z"
                fill="#01237A" />
            <path
                d="M17.5653 16.6526L17.2023 17.3651L17.9148 17.002L18.4801 17.5675L18.355 16.7777L19.0674 16.4147L18.2778 16.2897L18.1527 15.5L17.7898 16.2124L17 16.0873L17.5653 16.6526Z"
                fill="white" />
            <path
                d="M19.4102 11.3362L19.1468 11.8532L19.6637 11.5897L20.0739 12L19.9831 11.427L20.5 11.1636L19.9271 11.0729L19.8363 10.5L19.573 11.0168L19 10.9261L19.4102 11.3362Z"
                fill="white" />
            <path
                d="M17.4102 8.33627L17.1468 8.85319L17.6637 8.58976L18.0739 9.00003L17.9831 8.427L18.5 8.16363L17.9271 8.07293L17.8363 7.5L17.573 8.01686L17 7.92609L17.4102 8.33627Z"
                fill="white" />
            <path
                d="M14.4102 12.3363L14.1468 12.8532L14.6637 12.5898L15.0739 13L14.9831 12.427L15.5 12.1636L14.9271 12.0729L14.8363 11.5L14.573 12.0169L14 11.9261L14.4102 12.3363Z"
                fill="white" />
            <path
                d="M0 9.24077V9.98931H2.15527L0 11.4261V11.7788L2.6843 9.98926H3.74269L0 12.4844H5.23977V9.24073L0 9.24077ZM4.49123 12.4843H1.05862L4.49123 10.196V12.4843ZM8.23392 6.99516L11.9766 4.5H6.73684V7.7437H11.9766V6.99516H9.82133L11.9766 5.55825V5.20554L9.2923 6.99506L8.23392 6.99516ZM7.48538 4.50009H10.918L7.48538 6.78842V4.50009ZM6.73684 12.4844H11.9766L8.23392 9.98926H9.2923L11.9766 11.7789V11.4262L9.82133 9.98931H11.9766V9.24077H6.73684V12.4844ZM7.48538 10.196L10.918 12.4843H7.48538V10.196ZM5.23977 4.5H0L3.74269 6.99516H2.6843L0 5.20559V5.55829L2.15527 6.99511H0V7.74365H5.23977V4.5ZM4.49123 6.78842L1.05862 4.50009H4.49123V6.78842Z"
                fill="white" />
            <path
                d="M6.73684 4.5H5.23977V7.7437H0V9.24077H5.23977V12.4844H6.73684V9.24077H11.9766V7.7437H6.73684V4.5Z"
                fill="#D80027" />
            <path
                d="M3.74269 6.99516L0 4.5V5.20559L2.6843 6.99516H3.74269ZM8.23392 6.99516H9.2923L11.9766 5.20559V4.5L8.23392 6.99516ZM2.6843 9.98931L0 11.7789V12.4844L3.74269 9.98931H2.6843ZM8.23392 9.98931L11.9766 12.4844V11.7789L9.2923 9.98931H8.23392Z"
                fill="#D80027" />
        </svg>
    `),V=H`
    <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        static>
        <mask
            id="mask0_4915_40022"
            style="mask-type:alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="24"
            height="25">
            <circle
                cx="12"
                cy="12.5"
                r="12"
                fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0_4915_40022)">
            <path
                d="M-5 0.5H31V24.5H-5V0.5Z"
                fill="#01237A" />
            <path
                d="M21.348 18.7289L20.8035 19.7976L21.8721 19.253L22.7201 20.1012L22.5326 18.9165L23.6011 18.372L22.4166 18.1845L22.229 17L21.6846 18.0686L20.5 17.8809L21.348 18.7289Z"
                fill="white" />
            <path
                d="M24.1153 10.7544L23.7202 11.5297L24.4955 11.1346L25.1108 11.75L24.9747 10.8905L25.75 10.4954L24.8906 10.3594L24.7545 9.5L24.3595 10.2753L23.5 10.1391L24.1153 10.7544Z"
                fill="white" />
            <path
                d="M21.1153 6.2544L20.7202 7.02979L21.4955 6.63464L22.1108 7.25005L21.9747 6.3905L22.75 5.99545L21.8906 5.8594L21.7545 5L21.3595 5.77529L20.5 5.63914L21.1153 6.2544Z"
                fill="white" />
            <path
                d="M16.6153 12.2544L16.2202 13.0298L16.9955 12.6346L17.6108 13.25L17.4747 12.3905L18.25 11.9954L17.3906 11.8594L17.2545 11L16.8595 11.7753L16 11.6391L16.6153 12.2544Z"
                fill="white" />
            <path
                d="M-5 7.61116V8.73396H-1.76709L-5 10.8892V11.4182L-0.973544 8.73389H0.614035L-5 12.4766H2.85965V7.61109L-5 7.61116ZM1.73684 12.4765H-3.41207L1.73684 9.044V12.4765ZM7.35088 4.24274L12.9649 0.5H5.10526V5.36554H12.9649V4.24274H9.732L12.9649 2.08737V1.55832L8.93846 4.2426L7.35088 4.24274ZM6.22807 0.50014H11.377L6.22807 3.93263V0.50014ZM5.10526 12.4766H12.9649L7.35088 8.73389H8.93846L12.9649 11.4183V10.8893L9.732 8.73396H12.9649V7.61116H5.10526V12.4766ZM6.22807 9.044L11.377 12.4765H6.22807V9.044ZM2.85965 0.5H-5L0.614035 4.24274H-0.973544L-5 1.55839V2.08744L-1.76709 4.24267H-5V5.36547H2.85965V0.5ZM1.73684 3.93263L-3.41207 0.50014H1.73684V3.93263Z"
                fill="white" />
            <path
                d="M5.10526 0.5H2.85965V5.36554H-5V7.61116H2.85965V12.4766H5.10526V7.61116H12.9649V5.36554H5.10526V0.5Z"
                fill="#D80027" />
            <path
                d="M0.614035 4.24274L-5 0.5V1.55839L-0.973544 4.24274H0.614035ZM7.35088 4.24274H8.93846L12.9649 1.55839V0.5L7.35088 4.24274ZM-0.973544 8.73396L-5 11.4183V12.4766L0.614035 8.73396H-0.973544ZM7.35088 8.73396L12.9649 12.4766V11.4183L8.93846 8.73396H7.35088Z"
                fill="#D80027" />
        </g>
    </svg>
`,h=L("new_zealand_rounded",V),e=L("NZD",V);export{e as NZD,a as NewZealand,h as NewZealandRounded};
